'use strict';

export default class SnippetContent {
  constructor() {


    var controllerX = new ScrollMagic.Controller({globalSceneOptions: {triggerHook: 1}});


    let $slideUp = $('.js-slide-up');
    if ($slideUp.length){
      var $item = $('.js-slide-up');

      $.each($item,function(i, el){

        // var snippetContentIntro = $(this).find('.js-snippet-content-introheading');
        // var snippetContentHeading = $(this).find('.js-snippet-content-heading');
        // var snippetContentSubheading = $(this).find('.js-snippet-content-subheading');
        // var snippetContentBody = $(this).find('.js-snippet-content-body');
        // var line = $(this).find('.horizontal-line');

        var tween = new TimelineMax()
            .from(this, 0.8, {y:"+=100", opacity:0, ease: Power1.easeOut, delay: 0.3},"-=0.6")
            // .from(snippetContentHeading, 0.8, {x:"-=100", opacity:0, ease: Power1.easeOut},"-=0.6")
            // .from(snippetContentSubheading, 0.8 , {x:"-=100", opacity:0, ease: Power1.easeOut},"-=0.6")
            // .from(line, 0.8, {width:0, opacity:0},"-=0.8")

            // .from(this, 1, {y:"+=100", opacity:0, offset:-200,ease: Power1.easeInOut});


        //scenes
        var scene = new ScrollMagic.Scene({triggerElement: this})
                .setTween(tween)
                .addTo(controllerX)
                // .reverse(false);

      })


    }




    let $slideUpShort = $('.js-slide-up-short');
    if ($slideUpShort.length){
      var $item = $('.js-slide-up-short');

      $.each($item,function(i, el){

        var tween = new TimelineMax()
            .from(this, 0.6, {y:"+=60", opacity:0, ease: Power1.easeOut},"-=0.6")
        //scenes
        var scene = new ScrollMagic.Scene({triggerElement: this})
                .setTween(tween)
                .addTo(controllerX)
                // .reverse(false);

      })


    }


        let $snippetLine = $('.js-line');
        if ($snippetLine.length){
          var $item = $('.js-line');

          $.each($item,function(i, el){
            var controllerX = new ScrollMagic.Controller({globalSceneOptions: {triggerHook: 1}});

            var tween = new TimelineMax()
                .from(this, 0.6, {width:0, opacity:0, delay:0.5},"-=0.3")

            //scenes
            var scene = new ScrollMagic.Scene({triggerElement: this})
                    .setTween(tween)
                    .addTo(controllerX)
                    // .reverse(false);

          })
        }




  }




}
